module.exports = __webpack_public_path__ + "static/img/icon2.096e4e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/sakura/sanliouLinkage/lottery/winning/icon2.png
// module id = bHdY
// module chunks = 6